<template>
  <div class="pushDashboard pa-4">
    <v-card dark max-width="800" class="mx-auto card-glass" elevation="4">
      <v-card-title class="primary white--text text-h5 font-weight-bold">
        <v-icon left color="white">mdi-cellphone-message</v-icon>
        Push-Nachricht Senden
      </v-card-title>

      <v-card-text class="pt-6">
        <v-row>
          <v-col cols="12">
            <v-select
              filled
              v-model="selectedStudio"
              :items="studios"
              item-value="code"
              item-text="name"
              label="Empfänger-Studio auswählen"
              prepend-inner-icon="mdi-storefront"></v-select>

            <v-expand-transition>
              <v-alert v-if="selectedStudio && !loadingCount" :type="recipientCount > 0 ? 'info' : 'warning'" dense outlined class="mb-6">
                <span v-if="recipientCount > 0">
                  Diese Nachricht wird an ca. <strong>{{ recipientCount }} Geräte</strong> im Studio gesendet.
                </span>
                <span v-else> Achtung: Für dieses Studio sind aktuell keine Geräte registriert. </span>
              </v-alert>
            </v-expand-transition>

            <v-progress-linear v-if="loadingCount" indeterminate color="primary" class="mb-6"></v-progress-linear>

            <v-text-field filled label="Titel der Nachricht" v-model="title" counter="50" prepend-inner-icon="mdi-format-title"></v-text-field>

            <v-textarea filled label="Inhalt (Body)" v-model="body" counter="150" auto-grow rows="3" prepend-inner-icon="mdi-text"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pa-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" large :disabled="!isFormValid || recipientCount === 0" @click="confirmDialog = true">
          <v-icon left>mdi-send</v-icon>
          Push vorbereiten
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="confirmDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5 font-weight-bold error white--text"> Wirklich senden? </v-card-title>
        <v-card-text class="pt-4 text-body-1">
          Bist du sicher, dass du diese Push-Nachricht an <strong>{{ recipientCount }} Geräte</strong> senden möchtest? Das kann nicht rückgängig
          gemacht werden.

          <v-card class="mt-4 pa-3" outlined style="background-color: #f5f5f5">
            <strong>Titel:</strong> {{ title }}<br />
            <strong>Text:</strong> {{ body }}
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDialog = false">Abbrechen</v-btn>
          <v-btn color="error" :loading="isSending" @click="sendPush">Jetzt Senden</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../../api"

export default {
  name: "pushDashboard",
  data() {
    return {
      studios: [],
      selectedStudio: null,
      title: "",
      body: "",
      recipientCount: 0,
      loadingCount: false,
      confirmDialog: false,
      isSending: false,
    }
  },
  async created() {
    try {
      let studios = await api.fetchStudios()
      this.studios = studios
    } catch (e) {
      this.$toast.error("Studios konnten nicht geladen werden.")
    }
  },
  computed: {
    isFormValid() {
      return this.selectedStudio && this.title.trim().length > 0 && this.body.trim().length > 0
    },
  },
  watch: {
    selectedStudio(newStudioCode) {
      if (newStudioCode) {
        this.fetchRecipientCount(newStudioCode)
      } else {
        this.recipientCount = 0
      }
    },
  },
  methods: {
    async fetchRecipientCount(topic) {
      this.loadingCount = true
      try {
        let response = await api.getTopicAmount(topic)
        this.recipientCount = response.amount || 0
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler beim Berechnen der Empfänger.")
        this.recipientCount = 0
      } finally {
        this.loadingCount = false
      }
    },
    async sendPush() {
      this.isSending = true
      try {
        let notification = {
          topic: this.selectedStudio,
          notification: { title: this.title, body: this.body },
        }
        await api.sendPushToTopic(notification)

        this.$toast.success("Push-Nachricht wurde erfolgreich versendet!")
        this.confirmDialog = false

        // Formular zurücksetzen
        this.title = ""
        this.body = ""
        this.selectedStudio = null
      } catch (e) {
        this.$toast.error("Fehler beim Senden der Push-Nachricht.")
        console.error(e)
      } finally {
        this.isSending = false
      }
    },
  },
}
</script>
